module.exports = __webpack_public_path__ + "img/compare-dentistandpatient.a9397869.png";